export default __webpack_public_path__ + "static/media/AVLa.b.80f52c89.svg";